<template>

<div id="app">

  <router-view></router-view>

</div>

</template>

<script>
export default {
  name: 'App',
  methods: {
    setTitle: function() {
      document.title = 'Flooyd'
    }
  },
  mounted: function() {
    this.setTitle()
  }
}
</script>

<style lang="scss" scoped>
#app {
  overflow: hidden;
}
</style>
